export const PATIENT_SUPPORT_MOBILE_DIGITS = '989302707528';
export const PATIENT_SUPPORT_LANDLINE_E164 = '+982188652502';
